<script lang="ts" setup>
defineOptions({
  inheritAttrs: false,
});
defineProps<{
  items: {
    title: string;
    description: string;
  }[];
  title?: string;
  description?: string;
  innerClass?: string;
}>();
</script>

<template>
  <SectionHeader :title="title" :description="description" />
  <div :class="`py-8 ${$attrs.class}`">
    <div :class="innerClass">
      <Accordion type="single" collapsible class="w-full" default-value="item-1">
        <AccordionItem v-for="(item, index) in items" :key="index" :value="`item-${index + 1}`">
          <AccordionTrigger>{{ item.title }}</AccordionTrigger>
          <AccordionContent class="space-y-2 text-center">
            <p v-for="(paragraph, pIndex) in item?.description?.split('\n')" :key="pIndex" class="paragraph-md">
              {{ paragraph }}
            </p>
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </div>
  </div>
</template>
